const frenchUomMap: Record<string, string> = {
    AER: "AÉR",
    BAG: "SAC",
    BALE: "BAL",
    BDL: "BAT",
    BFT: "PMP",
    BOX: "BTE",
    BTL: "BTL",
    BULK: "VRAC",
    CAN: "POT",
    CASE: "CAIS",
    COIL: "BOB",
    CRT: "PLAT",
    CRTG: "CRTG",
    CTN: "CTN",
    CUBE: "CUBE",
    CY: "VG³",
    CYL: "CYL",
    DRUM: "FÛT",
    EA: "UN",
    GAL: "GAL",
    INCH: "PO",
    JAR: "VASQ",
    JUG: "BID",
    KG: "KG",
    KIT: "TRS",
    LB: "LB",
    LF: "PL",
    LITR: "L",
    LM: "ML",
    LOT: "LOT",
    METR: "M",
    OZ: "OZ",
    PACK: "PAQ",
    PAIL: "SEAU",
    PAIR: "PAIR",
    PC: "PC",
    PINT: "CHOP",
    QT: "PTE",
    REEL: "BOB",
    ROLL: "ROUL",
    SAUS: "BOUD",
    SET: "ENS",
    SF: "PI2",
    SHT: "FEUI",
    SKID: "PAL",
    SM: "M2",
    THOU: "MILL",
    TON: "T",
    TOTE: "BAC",
    TUB: "CONT",
    TUBE: "TUBE",
    YD: "VG",
};

export const getTranslatedUom = (uom: string, language?: string) => {
    if (language !== "fr-CA") {
        return uom;
    }

    return frenchUomMap[uom] ?? uom;
};